const BLUR_POWER_MAP = {
  soft: 6,
  medium: 25,
  hard: 50
};
export default function create(options) {
  const {
    blur = 6,
    power,
    range = 'in'
  } = options.namedEffect;
  const blurFactor = power && BLUR_POWER_MAP[power] ? BLUR_POWER_MAP[power] : blur;
  const fromValue = range === 'out' ? 0 : blurFactor;
  const toValue = range === 'out' ? blurFactor : 0;
  const easing = 'linear';
  return [{
    ...options,
    easing,
    composite: 'add',
    keyframes: [{
      filter: `blur(${fromValue}px)`
    }, {
      filter: `blur(${toValue}px)`
    }]
  }];
  /*
   * @keyframes <name> {
   *   from {
   *     filter: blur(<fromValue>px);
   *   }
   *   to {
   *     filter: blur(<toValue>px);
   *   }
   * }
   */
}
//# sourceMappingURL=BlurScroll.js.map